import { AiButton, AiTag } from './ui';

// Пометка «ИИ» у параметра техники (загрузка техники файлом, спека §11):
// значение — справочные данные ИИ, его сверяют с паспортом машины. Подробности
// — и во всплывающей подсказке, и в aria-label: title клавиатуре и экранному
// диктору недоступен.

/** Значок «ИИ» только для чтения (справочник, паспорт черновика); фокусируемый. */
export function AiMarkTag({ details }: { details: string }) {
  return (
    <AiTag role="img" tabIndex={0} title={details} aria-label={details}>
      ИИ
    </AiTag>
  );
}

/**
 * «ИИ ×» в таблице проверки и в таблице мастера: нажатие — значение сверено с
 * паспортом, пометка снимается (само значение не меняется).
 */
export function AiMarkButton({
  details,
  onClear,
  disabled = false,
}: {
  details: string;
  onClear: () => void;
  disabled?: boolean;
}) {
  return (
    <AiButton
      type="button"
      disabled={disabled}
      title={`${details}\nНажмите, если значение сверено с паспортом, — пометка «ИИ» снимется.`}
      aria-label={`Значение сверено с паспортом — снять пометку ИИ. ${details}`}
      onClick={onClear}
    >
      ИИ <span aria-hidden="true">×</span>
    </AiButton>
  );
}
